<div class="row toolbar align-items-center p-0" style="box-shadow: 0px 4px 4px #0000001f;">
  <!-- Menu icon -->
  <div *ngIf="!isBack" (click)="openSideNav()" class="menu align-self-center p-0 mr-2">
    <span class="material-icons-outlined d-flex"> menu </span>
  </div>

  <div *ngIf="isBack" (click)="goBack()" class="menu col align-self-center px-1" style="max-width: 45px;">
    <i class="bi bi-chevron-left"></i>
  </div>

  <!-- Toolbar name -->
  <div class="col toolbarLabel pl-0">

    <div class="d-flex align-items-center justify-content-between w-100">

      <div *ngIf="this.layoutService.toolbarDetails?.isShopFiltered === true"
        class=" d-flex flex-column align-items-start justify-content-center">
        <div class="ellipsis" style="font-weight: 800;">{{ this.layoutService.toolbarDetails.shopName }}</div>
        <div style="font-weight: 700; font-size: 14px; line-height: 1;">{{ this.layoutService.toolbarDetails.title }}
        </div>
      </div>

      <div *ngIf="this.layoutService.toolbarDetails?.isShopFiltered !== true"
        class="d-flex flex-column align-items-start justify-content-center">
        <div (click)="gotoPage('/servicenear/dashboard')" style="font-weight: 700;">
          {{this.layoutService.toolbarDetails.title }}</div>
      </div>

      <div class="d-flex align-items-center ">
        <div *ngIf="this.layoutService.toolbarDetails?.isShopService === true" class="d-flex align-items-center"
          style="font-size: 15px;">
          <div><i style="font-size:20px;" class="bi bi-shop ml-0 mr-2"></i></div>
          <div class="ellipsis" style="max-width: 150px;">{{this.layoutService.toolbarDetails?.shopName}}</div>
        </div>
        <div *ngIf="this.layoutService.toolbarDetails?.isCustomerService === true" class="d-flex align-items-center"
          style="font-size: 15px;">
          <div><i style="font-size:20px;" class="bi bi-person ml-0 mr-2"></i></div>
          <div class="ellipsis" style="max-width: 150px;">{{this.layoutService.toolbarDetails?.customerName}}</div>
        </div>

        <div class="navbar-buttons d-flex" style="gap:0.5rem">
          <ng-container *ngFor="let btn of this.layoutService.navbarButtons">
            <div *ngIf="btn.action === 'call' && (this.layoutService.toolbarDetails?.customerName || this.layoutService.toolbarDetails?.shopName)" class="ml-2 call-btn" (click)="onButtonClick(btn)">
              <i class="bi bi-telephone-fill p-0 m-0" style="font-size: 16px;"></i>
            </div>

            <div *ngIf="btn.action === 'expressjob'" (click)="onButtonClick(btn)" [ngClass]="{
                'disabled-privilege': 
                  !this.privilegeService.getServicenearPrivilege('addJob', true) ||
                  !this.privilegeService.getServicenearPrivilege('addExpressJob', true)
              }">
              <img [src]="btn.image" style="width: 55px; height: 30px;object-fit: contain;" alt="express">
            </div>

            <button *ngIf="btn.action !== 'call' && btn.action !== 'expressjob' " style="background-color: #673AB7;color:#fff;"
              class="d-flex align-items-center justify-content-center p-0" (click)="onButtonClick(btn)">
              <span style="font-size: 30px;" class="material-icons">
                {{btn.icon}}
              </span>
            </button>

          </ng-container>
        </div>

      </div>

    </div>

  </div>

</div>